import { useResorts } from "@/queries/hooks"

import { useResortParam } from "../useSkipassFlow"

const useSelectedResort = () => {
  const { resortExternalId } = useResortParam()
  const { data: resortData, ...other } = useResorts()

  const selectedResort = resortData?.find(
    (resort) => resort.externalId === resortExternalId
  )

  return { selectedResort, ...other }
}

export default useSelectedResort
